//本人証明用ページ 確認用パスワード入力 /auth/:uid/:cid
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import './css/auth.css';
import {Link,browserHistory} from 'react-router'
//import firebase from 'firebase'
//import {getCertificationCode} from './firebase'

import './css/toast_custom.css';
import Toast from './components/toast'

//ユーザランク取得処理
import {
  getUserRank
} from './functions/getUserRank'
import {IsLoading} from './loading';

export default class App extends Component {

  constructor() {
    super();
    this.state = {
      displayName: "",
      photoURL: "",
      certificationCode:[],

      code:"",
      uid:"",
      cid:"",
      
      error_message:'',

      rank:"",
      rank_img:"",
      rank_class:"",
      rank_jp:"",
      rank_class_jp:"",
      rank_chart:"",
      yahoo_auction:[],
      coconala:[],
      anyca:[],
      notteco:[],
      spacemarket:[]
    };
  }

  componentDidMount() {
    let path = window.location.pathname;
    let path_arr = path.split("/");
    var uid = "";
    var cid = "";
    if ("" !== path_arr[2] && null !== path_arr[2] && "undefined" !== typeof path_arr[2]) {
      uid = path_arr[2];
    } else {
      // err
      browserHistory.push("/");
    }
    if ("" !== path_arr[3] && null !== path_arr[3] && "undefined" !== typeof path_arr[3]) {
      cid = path_arr[3];
    } else {
      // err
      browserHistory.push("/");
    }

    this.setState({uid: uid});
    this.setState({cid: cid});

    var scope = this
    
    //ユーザー情報取得APIをたたく（非ログインユーザー用）
    let getUserData = (uid) => {
      let xhr = new XMLHttpRequest()
      xhr.onreadystatechange = () => {
        if(xhr.readyState === 4) {
          if(xhr.status === 200) {
            //console.log(xhr.response)
            let res = JSON.parse(xhr.response)
            getUserRank(uid, scope, true, res)
            scope.setState({displayName: res.displayName});
            scope.setState({photoURL: res.updatePhoto ? res.updatePhoto : "https://graph.facebook.com/" + res.facebookId + "/picture?width=250&height=250"});
            scope.setState({certificationCode: res.certificationCode});
          }
        }
      }
      xhr.open('POST','/api/getUser')
      xhr.setRequestHeader('Content-Type','application/json')
      xhr.send(JSON.stringify({uid:uid}))
    }
    //非ログインユーザーはDBに直接アクセス権がないのでAPIを叩く
    getUserData(uid)


    // 照会された回数とリファラーを記録
    var referrer = "";
    if (document.referrer) {
      referrer = document.referrer;
    }
    //照会された回数とリファラーを記録
    let recordCertification = (uid,referrer) => {
      let xhr = new XMLHttpRequest()
      xhr.onreadystatechange = () => {
        if(xhr.readyState === 4) {
          if(xhr.status === 200) {
          }
        }
      }
      xhr.open('POST','/api/recordCertification')
      xhr.setRequestHeader('Content-Type','application/json')
      xhr.send(JSON.stringify({
        uid:uid,
        referrer:referrer
      }))
    }
    recordCertification(uid, referrer);
  }

  handleChangeCode(code) {
    this.setState({"code": code});
  }

  checkIdentification(e) {
    var scope = this
    // 有効期限内か
    //var cd = new Date(); 
    //var datetime = cd.getFullYear() + "-" + ("0"+(cd.getMonth()+1)).slice(-2)  + "-" + ("0"+cd.getDate()).slice(-2) + " " + ("0"+cd.getHours()).slice(-2) + ":" + ("0"+cd.getMinutes()).slice(-2) + ":" + ("0"+cd.getSeconds()).slice(-2);
    //var now = new Date(datetime);
    var now = Date.now()
    let error_msg_text = ''
    for (var n in scope.state.certificationCode) {
      var arr = scope.state.certificationCode[n].created_at.split(/[- :]/)
      var targetDate = Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]))
      //var targetDate = new Date(scope.state.certificationCode[n].created_at);
      //var diff = (now.getTime() - targetDate.getTime()) / (1000 * 60 * 60);
      var msDiff = now - targetDate
      var diff = msDiff / (1000 * 60 * 60)
      //console.log(now,targetDate,msDiff,diff)
      // 期間=24時間以内(23時間59分59秒99まで)
      if (24 > diff) {
        // certificationCodeが合っているか
        if (Number(scope.state.cid) === scope.state.certificationCode[n].cid) {
          if (scope.state.code === scope.state.certificationCode[n].certificationCode) {
            // 認証完了
            //browserHistory.push("/user/" + scope.state.uid);
            browserHistory.push({
              pathname:"/user/" + scope.state.uid,
              state:{
                isCertification:true,
                uid:scope.state.uid
              }
            })
          } else {
            // 認証コード間違い
            error_msg_text = (<div className="toast-caution"><p>※証明証番号が違います。</p></div>)
          }
        }
      } else {
        // リンクの有効期限切れ
        error_msg_text = (<div className="toast-caution"><p>※リンクの有効期限が切れています。</p></div>)
        //browserHistory.push("/user/" + scope.state.uid);
      }
    }
    scope.setState({error_message:error_msg_text})
  }

  returnToast = () => {
    const {
      error_message
    } = this.state
    if(error_message) {
      return (
        <Toast notifyMessage={error_message} />
      )
    }
  }

  isLoading = () => {
    const {
      rank_chart,
      photoURL,
      displayName
    } = this.state
    if(rank_chart && photoURL) {
      return (
        <div className="block-thum clearfix">
          <img className="user-chart" src={rank_chart} alt="" />
          <img className="user-thum" src={photoURL} alt="" />
          <p className="text-center user-name">{displayName}</p>
          <p className="text-center user-address">Japan</p>
        </div>
      )
    } else {
      return IsLoading()
    }
  }

  render(){
    const {
      displayName
    } = this.state
    return (
      <div>
        <div id="wrapper">
        { this.returnToast() }
        <div id="" className="wrapper-lp wrapper-auth">
          <Header/>
          <div className="webWrap">
            <div className="wrapCover">
              <div className="wrapCover__contentBlock clearfix">
                <div className="content-top">
                  <h2 className="title">Personal Identification</h2>
                  <p className="subtitle">証明番号を入力しましょう</p>
                  <p className="text-notification">他人の信用情報を悪用するなりすましを防止するために、{displayName}さん本人しか発行できない暗証番号を用いて認証を行います。</p>
                  { this.isLoading() }
                  <p className="text-notification">{displayName}さんのMyRateを見るためには、認証番号を入力してください。</p>
                </div>
                <form>
                  <input className="auth-num" type="text" name="auth-num" onChange={(e) => {this.handleChangeCode(e.target.value)}} />
                  <div className="btnAction">
                      <Link className="btn-submit" onClick={(e) => {this.checkIdentification(e)}}>MyRateを確認する</Link>
                  </div>
                </form>

              </div>
              <Footer/>
              <div className="cardCover white-cover"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/auth.js